import React, { useEffect, useState } from "react";
import ActionButton from "../../ActionButton";
import { Link } from "react-router-dom";
import { useTranslate } from "../../TranslationText";
import { useDispatch, useSelector } from "react-redux";
import Album from "../../Album";
import OwlCarousel from "react-owl-carousel";
import { showFirstFourWords, showFirstSixWords } from "../../../helper/showFirstSixWords";
import Lightbox from "react-18-image-lightbox";
import {
  FetchShowsGallery,
  FetchShowsNews
} from "../../../Redux/Shows/ShowsAction";
import CompetitionsTab from "../../CompetitionsTab";
import Popup from "reactjs-popup";
import { incrementPageHorseCompetition } from "../../../Redux/StudBook/StudBookSlice";
import PillBtn from "../../PillBtn";
import { formatDateTimeInArabic } from "../../../helper/formateDateTimeToArabic";
import AuctionHorseCard from "./AuctionHorseCard";
import axiosInstance from "../../../axios/axios";
import EahsForm from "../../EahsForm";
import { noDataCard } from "../../../common/cssclasses";

const BaseURL = process.env.REACT_APP_BASE_URL;
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;



export default function AuctionDetails({
  data,
  auctionHorses,
  auctionData,
  paymentStatus,
  bidderNumber,
  bidderId,
  currentAuctionId,
}) {
  const {
    showNewsData,
    showMediaData,
  } = useSelector((state) => state.showsSlice);
  const {

    studBookHorseCompetitionData,
    takeHorseCompetition,
    pageHorseCompetition,
    totalCountHorseCompetition,
    studBookPedigreeData
  } = useSelector((state) => state.studBookSlice);
  const handlePageChangeHorseCompetition = (page) => {
    dispatch(incrementPageHorseCompetition(page));
  };
  const renderPaginationHorseCompetition = () => {
    const pages = [];

    const numPages = Math.ceil(
      totalCountHorseCompetition / takeHorseCompetition
    );

    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <React.Fragment>
          <span
            className="btn btn-dark mx-auto"
            key={i}
            onClick={() => handlePageChangeHorseCompetition(i)}
          >
            {i}
          </span>
        </React.Fragment>
      );
    }

    let _pages = [];

    if (pages.length >= 5 && pageHorseCompetition === 1) {
      _pages = pages
        .slice(pageHorseCompetition - 1, 3)
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageHorseCompetition > 1) {
      _pages = pages.slice(pageHorseCompetition);
    }
    if (pageHorseCompetition > 1 && numPages - pageHorseCompetition > 3) {
      _pages = pages
        .slice(pageHorseCompetition - 1, pageHorseCompetition)
        .concat(_pages.slice(0, 2))
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageHorseCompetition === 1 && numPages - pageHorseCompetition <= 3) {
      _pages = pages;
      if (studBookHorseCompetitionData.length === 0) {
        _pages = [];
      }
    }

    if (pageHorseCompetition > 1 && numPages - pageHorseCompetition <= 3) {
      _pages = pages
        .slice(pageHorseCompetition - 1, pageHorseCompetition)
        .concat(_pages.slice(0, 3));
    }

    return _pages;
  };

  const paginiateStyle = {
    padding: '10px 20px',
    color: "#fff",
    cursor: "pointer",
    margin: 'auto',
    borderRadius: 5,
  };



  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const currentlang = localStorage.getItem('eahsLang') ?? 'en';

  const [allHorsesActive, setAllHorsesActive] = useState(true);
  const [soldHorsesActive, setSoldHorsesActive] = useState(false);
  const [unsoldHorsesActive, setUnsoldHorsesActive] = useState(false);
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const { translate } = useTranslate();

  function gethourseImageURL(horse) {
    const imageurls = horse.horseAttachment.filter(
      (item) => item.entity === "AuctionHorse"
    );

    if (
      !!imageurls[0] &&
      imageurls[0].fileUrl !=
      "https://dev.eahs.org:8016/ImagesUploads/89def8e1-57e9-4524-a86b-bbf7571e50b7_download.png"
    ) {
      return imageurls[0].fileUrl;
    } else {
      return `${BaseURL}/assets/img/horseauction.png`;
    }
  }

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }



  // pagination proccess
  const pageSize = 15; // Number of horses per page
  // State variables for pagination
  const [currentPage, setCurrentPage] = useState(1);

  // Function to handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  // Update total number of horses based on the active tab
  const filteredHorses = auctionHorses.filter((horseData) => {
    if (allHorsesActive) {
      return true; // Show all horses
    } else if (soldHorsesActive) {
      return horseData.horseSellingStatus === "Sold"; // Show sold horses
    } else if (unsoldHorsesActive) {
      return (
        horseData.horseSellingStatus !== "Sold"
      ); // Show unsold horses
    }
    return true; // Default to show all horses
  });

  // Update totalHorses, totalPages, and currentPage based on filteredHorses
  const totalHorses = filteredHorses.length;
  const totalPages = Math.ceil(totalHorses / pageSize);

  // Calculate index range for current page
  // const startIndex = (currentPage - 1) * pageSize;
  const startIndex = 0;
  const endIndex = Math.min((currentPage) * pageSize, totalHorses);

  // Slice auctionHorses based on current page and filter based on the active tab
  const displayedHorses = filteredHorses.slice(startIndex, endIndex);

  const horsePerPage = 16;
  const [activeTab, setActiveTab] = useState('All')

  async function getHorseList(type = 'All', isloadMore = false) {
    try {
      const res = await axiosInstance.get(`/auction/getauctionhorsesbyid?Id=${auctionData?.auuctionId}&skip=0&take=${horsePerPage}&SellingStatus=${type}`)
    } catch (error) {

    }
  }

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [images, setimages] = useState([]);
  const dispatch = useDispatch();


  const handleHorseMedia = (index, albumMedia) => {
    setIsOpen(true);
    setPhotoIndex(index);
    setimages(albumMedia.map((media) => MediaBaseURL + media.url));
  };

  useEffect(() => {
    let param = { id: auctionData.auuctionId, langauge: currentLanguage }
    dispatch(FetchShowsGallery(param));
    dispatch(FetchShowsNews(param));
  }, [currentLanguage])

  const tabsClasses = 'col-lg-3 col-md-4 col-sm-6 col-8 my-2 px-0 text-center px-0';

  return (
    <>
      {isOpen && (
        <div>
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % images.length)
            }
            wrapperClassName='ltr'
          />
        </div>
      )}

      <div className="row mx-0 rtl">
        <div
          className={'col-4  text-center px-0 mb-main'}
          style={{ cursor: 'pointer' }}
          id="second_most_used_services"
          onClick={() => {
            setAllHorsesActive(true);
            setSoldHorsesActive(false);
            setUnsoldHorsesActive(false);
            setActiveTab('All')
          }}
        >
          <span className={`${activeTab == 'All' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.all", "All")}</span>
          <div className="service_bar_underline" style={activeTab == 'All' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
        </div>

        <div
          className={'col-4  text-center px-0 mb-main'}
          id="second_registration_services"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setAllHorsesActive(false);
            setSoldHorsesActive(true);
            setUnsoldHorsesActive(false);
            setCurrentPage(1);
            setActiveTab('Sold')
          }}
        >
          <span className={`${activeTab == 'Sold' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.sold", "Sold")}</span>
          <div className="service_bar_underline" style={activeTab == 'Sold' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
        </div>


        <div
          className={'col-4  text-center px-0 mb-main'}
          id="second_notarisation_services"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setAllHorsesActive(false);
            setSoldHorsesActive(false);
            setUnsoldHorsesActive(true);
            setCurrentPage(1);
            setActiveTab('UnSold')
          }
          }
        >

          <span className={`${activeTab == 'UnSold' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.Unsold", "Unsold")}</span>
          <div className="service_bar_underline" style={activeTab == 'UnSold' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
        </div>
      </div>


      <div className="row rtl"  >
        
        {displayedHorses.map((horse, index) => (
          <>
            <AuctionHorseCard
              gethourseImageURL={gethourseImageURL}
              horse={horse}
              translate={translate}
              formatDate={formatDate}
              pageHorseCompetition={pageHorseCompetition}
              takeHorseCompetition={takeHorseCompetition}
              currentlang={currentlang}
              dispatch={dispatch}
              windowWidth={windowWidth}
              studBookHorseCompetitionData={studBookHorseCompetitionData}
              handlePageChangeHorseCompetition={handlePageChangeHorseCompetition}
              renderPaginationHorseCompetition={renderPaginationHorseCompetition}
              totalCountHorseCompetition={totalCountHorseCompetition}
              auctionData={auctionData}
              bidderId={bidderId}
              bidderNumber={bidderNumber}
              currentAuctionId={currentAuctionId}
            />
          </>
        ))}
      </div>

      {currentPage !== totalPages && auctionHorses.length > 0 && (
        <>
          <div className={noDataCard}>
            {translate('web.noDataFound', 'No Horses')}
          </div>
        </>
      )}



    </>
  );
}